<!-- Button trigger modal -->
<button class="btn btn-block background-primary mb-2 p-2 w-100" data-bs-toggle="modal" data-bs-target="#productModal">
    <h2>Agregar</h2>
</button>
  
  <!-- Modal -->
  <div class="modal fade" id="productModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl container-fluid">
      <div class="modal-content">
        <div class="modal-header background-secondary">
          <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="form">
            <div class="row m-4">
                <div class="col-4">
                    <label class="form-label">Nombre</label>
                    <input type="text"
                           class="form-control"
                           formControlName="name"
                           
                           placeholder="Ingrese un nombre..."
                           [class.is-invalid]="invalidName"
                           >
                    <small *ngIf="invalidName" class="text-danger">Escoja un nombre de entre 1 y 50 caracteres</small>
                  </div>
                <div class="col-8">
                    <label class="form-label">Descripcion</label>
                    <input 
                        class="form-control" 
                        type="text"
                        
                        formControlName="description" 
                        placeholder="Ingrese una descripcion"
                        [class.is-invalid]="invalidDescription"
                        >
                    <small *ngIf="invalidDescription" class="text-danger">Escoja una descripcion de entre 1 y 100 caracteres</small>
                  </div>
            </div>
            <div class="row m-4">
              <div class="col-4">
                  <label class="form-label">URL de imagen</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    formControlName="imgUrl" 
                    
                    placeholder="https://...."
                    [class.is-invalid]="invalidImgUrl"
                    >
                  <small *ngIf="invalidImgUrl" class="text-danger">Ingrese una url o suba una imagen</small>
                  <input class="form-input" type="file" (change)="upload($event)" accept="image/*">
              </div>
              <div class="col-4">
                  <label class="form-label">Precio</label>
                  <input 
                    type="number"
                    class="form-control" 
                    formControlName="price" 
                    
                    placeholder="Ingrese un precio..."
                    [class.is-invalid]="invalidPrice"
                    >
                </div>
                <div class="col-4">
                  <label class="form-label">Descuento</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    formControlName="discount" 
                    placeholder="Ingrese un descuento"
                    [class.is-invalid]="invalidDiscount"
                    
                    >
                </div>
          </div>
          <div class="row m-4">
              <div *ngFor="let t of talles" class="form-check col">
                  <input class="form-check-input" type="checkbox"  [formControlName]="t">
                  <label class="form-check-label" [for]="t">
                    {{ t }}
                  </label>
              </div>
                <small class="text-danger" *ngIf="invalidTalles">Elija al menos un talle</small>
          </div>
          <div class="row m-4">
              <div class="col">
                  <select class="form-select" formControlName="category" [class.is-invalid]="invalidCategory"  >
                      <option>Elige categoría</option>
                      <option *ngFor="let cat of categories" [ngValue]="cat?.name">{{cat.name}}</option>
                    </select>
              </div>
              <div class="form-check col-3">
                  <input class="form-check-input" type="checkbox" value="" formControlName="isTrending">
                  <label class="form-check-label">
                    Es destacado
                  </label>
              </div>
              <div class="form-check col-3">
                  <input class="form-check-input" type="checkbox" value="" formControlName="isVisible">
                  <label class="form-check-label">
                    Esta visible
                  </label>
              </div>
          </div>
        </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn bg-orange" (click)="postForm()">Agregar</button>
        </div>
      </div>
    </div>
  </div>